/**
 * @dtsModule max.media
 * @dtsNamespace media
 * @dtsDesc media Media
 */
export const media = {
  /**
   * @dtsExport
   * Select pictures
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.media.choose&lang=%{locale}%)
   */
  choose(props: ChooseImageProps): Promise<(File | { path: string, size: number })[]> {
    //TODO:取消的问题待处理
    const { fileType: _fileType } = props
    return new Promise<(File | { path: string, size: number })[]>((resolve, reject) => {
      let fileType = _fileType || "image/*"
      const input = document.createElement("input")
      input.setAttribute("type", "file")
      input.setAttribute("multiple", "multiple")
      input.setAttribute("accept", fileType)
      input.click()
      input.onchange = function () {
        const files = input.files
        resolve(files as any)
      }
      input.remove()
    })
  },
}
